import React, { FunctionComponent } from 'react';

type Props = {
  title: string;
  name: string;
  items: any;
  targets: any;
  handleClick: (event: any) => void;
};

export const Presentation: FunctionComponent<Props> = ({ title, name, items, targets, handleClick }) => {
  const handleOpen = (event: any) => {
    const target = $(event.target).next();
    $('.js-slideToggle').not(event.target).removeClass('active');
    $(event.target).toggleClass('active');
    $('.js-slideToggle').not(event.target).next().slideUp();
    target.slideToggle();
  };

  return (
    <li className="l-header__unloggedModal__wrapper__list--item">
      <p onClick={handleOpen} className="title js-slideToggle">
        {title}
      </p>
      <div className="content">
        <ul className="l-header__unloggedModal__wrapper__list--item--child">
          {name === 'target_employment_types' &&
            items.length > 0 &&
            items.map((item: any) => (
              <li key={item} onClick={handleClick}>
                <input
                  type="checkbox"
                  checked={targets && targets.includes(item)}
                  onChange={handleClick}
                  onClick={(event) => event.stopPropagation()}
                  className="checkbox-input"
                  value={item}
                  name={name}
                />
                <span className="checkbox-icon"></span>
                <span className="checkbox-text">{item}</span>
              </li>
            ))}
          {name !== 'target_employment_types' &&
            items.length > 0 &&
            items.map((item: any) => (
              <li
                key={item.name}
                onClick={handleClick}
                className={`${name === 'target_occupations' ? 'fullWidth' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={targets && targets.includes(String(item.id))}
                  onChange={handleClick}
                  onClick={(event) => event.stopPropagation()}
                  className="checkbox-input"
                  value={item.id}
                  name={name}
                />
                <span className="checkbox-icon"></span>
                <span className="checkbox-text">{item.name}</span>
              </li>
            ))}
        </ul>
      </div>
    </li>
  );
};
